import React, { FC, useMemo } from 'react';

import usePixelRatio from '../../../hooks/_usePixelRatio';
import { StyledBullet } from './Bullet.styles';

export interface BulletProps {}
export interface BulletStatics {
  StyledBullet: typeof StyledBullet;
}

const Bullet: FC<BulletProps> & BulletStatics = (props) => {
  const pixelRatio: number = usePixelRatio();

  const needsBulletAdjustment = useMemo(() => Boolean((pixelRatio * 10) % 2), [pixelRatio]);
  const needsRadioAdjustment = useMemo(() => Boolean((pixelRatio * 20) % 2), [pixelRatio]);

  return (
    <StyledBullet
      role="presentation"
      pixelRatio={pixelRatio}
      needsRadioAdjustment={needsRadioAdjustment}
      needsBulletAdjustment={needsBulletAdjustment}
      {...props}
    />
  );
};

Bullet.StyledBullet = StyledBullet;

export default Bullet;
